<ng-container *ngIf="linksMap$ | async as linksMap">
  <div *ngIf="linksMap.size > 0" class="mx-6 mt-4">
    <div class="mb-2">
      <dcp-text-links [links]="linksMap.get(aboutLinksNode)"></dcp-text-links>
    </div>
    <div class="md-mb-2">
      <dcp-text-links [links]="linksMap.get(legalLinksNode)"></dcp-text-links>
    </div>
    <div class="md-mb-2">
      <dcp-social-media [links]="linksMap.get(socialMediaLinksNode)"></dcp-social-media>
    </div>
  </div>
</ng-container>
